import { render, staticRenderFns } from "./RespOrg.vue?vue&type=template&id=80da59d6&scoped=true&"
import script from "./RespOrg.vue?vue&type=script&lang=js&"
export * from "./RespOrg.vue?vue&type=script&lang=js&"
import style0 from "./RespOrg.vue?vue&type=style&index=0&id=80da59d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80da59d6",
  null
  
)

export default component.exports